import { surfaces } from '../theme/colors';
import { Box, useTheme } from '@mui/material';

const AppBackground = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: -1,

        /* Critical for iOS */
        minHeight: '100dvh',
        width: '100vw',
        overflow: 'hidden',

        backgroundColor: isDark ? '#050611' : surfaces.lightGround,
      }}
    >
      {isDark && (
        <>
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: `
                radial-gradient(
                  1200px 800px at 25% 20%,
                  rgba(56,189,248,0.45),
                  transparent 60%
                ),
                radial-gradient(
                  1000px 700px at 75% 25%,
                  rgba(99,102,241,0.40),
                  transparent 60%
                ),
                radial-gradient(
                  900px 700px at 50% 80%,
                  rgba(236,72,153,0.35),
                  transparent 65%
                )
              `,
              filter: 'blur(120px)',
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'radial-gradient(circle at center, transparent 40%, rgba(0,0,0,0.55) 85%)',
              pointerEvents: 'none',
            }}
          />
        </>
      )}

      {/* Daylight Glass: the dark mode aurora, lightened, with no white wash over it */}
      {!isDark && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: `
              radial-gradient(
                1100px 720px at 12% 8%,
                rgba(56,189,248,0.30),
                transparent 62%
              ),
              radial-gradient(
                1000px 700px at 88% 18%,
                rgba(139,92,246,0.24),
                transparent 62%
              ),
              radial-gradient(
                1200px 800px at 55% 100%,
                rgba(255,47,146,0.20),
                transparent 66%
              )
            `,
          }}
        />
      )}
    </Box>
  );
};

export default AppBackground;